import React from 'react';

import Choosepet from './Choosepet';
import Diameter from './Diameter';
import Dishatabl from './Dishatabl';


const Choosepetprefo = () => {
    return (
        <div>
            <Choosepet />
            <Diameter />
            <Dishatabl />
        </div>
    );
};

export default Choosepetprefo;
